// extracted by mini-css-extract-plugin
module.exports = {"small":"_3c69rcmO","large":"_3-xpZ4j1","wrapper":"_3fl0tYCa","cred":"_2eNAzHFq","truncated":"_3_Xr7kX7"};